import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AccountDebtorService } from './accountDebtor.service';
import { GetUserPermissionGQL } from '../generated/cloudapigql';
import { Permission } from '../generated/accountgql';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class ACLService {
  currentUserPermission = new BehaviorSubject<any>({});
  private permissionList = [];
  constructor(
    private getUserPermissionGQL: GetUserPermissionGQL,
    private accountDebtorService: AccountDebtorService,
    private authService: AuthenticationService,
  ) {
    this.initUserPermissionData();
    this.accountDebtorService.AccountDebtorSubscription.subscribe(x=>{
      if(x){
        this.initUserPermissionData();
      }
    })
  }

  initUserPermissionData() {
    this.currentUserPermission.next(null);
    this.permissionList = [];
    this.getUserPermissionGQL
    .fetch()
    .subscribe((result) => {
        if (result.errors) {
            this.currentUserPermission.next(null);
        } else {
            let permission = Array.from(new Set(result.data.getUserRoleByUserId.flatMap(x=>x.permissions.map(x=>x.permissionCode))));
            this.currentUserPermission.next(permission);
            this.permissionList = permission;
        }
    });
  }

  getUserPermissionData() {
    return this.getUserPermissionGQL.fetch();
  }

  userPermissionChecking(permissions:string[]){
    //tenant don have super user access
    // if(this.authService.userContext.isSuperUser){
    //   return true;
    // }
    return this.permissionList.some(x=> permissions.some(y=>y == x))
  }

}
